import { enTranslations, nlTranslations } from '@zig-design-system/shared';
import get from 'lodash.get';

export class LocaleService {
	static locale: string = 'en';
	private static translationOverrides: object = {};

	private static getRawTranslation(id: string) {
		const override = get(LocaleService.translationOverrides, id);
		if (override) return override;

		const isDutch = LocaleService.locale.toLowerCase().startsWith('nl');
		const localeTranslations = isDutch ? nlTranslations : enTranslations;

		// Return translation by ID, or return the id if not found
		return get(localeTranslations, id, id);
	}

	static t(id: string, parameters: Record<string, string | number> = {}) {
		let translation = LocaleService.getRawTranslation(id);
		Object.entries(parameters).forEach(([name, value]) => {
			if (value === undefined || value === null) {
				console.error(`Invalid value '${value}' for parameter '${name}' of translation ${id}`);
				return;
			}

			translation = translation.replace(new RegExp(`\\{\\{${name}\\}\\}`), value.toString());
		});
		return translation;
	}

	static setTranslationOverrides(overrides: object) {
		LocaleService.translationOverrides = overrides;
	}
}
